import Icon from 'veui/components/Icon'
import { IconAlignCenter } from 'dls-icons-vue'

Icon.register('align-center', IconAlignCenter)
